/** @jsx isolateComponent */

import React from 'react';
import { isolateComponent } from '@zapier/common-utils';
import {
  UniversalNav,
  UniversalNavPageLayout,
} from '@zapier/design-system-patterns';

import ContentFooter from 'web-ssr/app/common/components/ContentFooter';

type Props = {
  /**
   * Content to render within the page.
   */
  children: React.ReactNode;
  /**
   * Content to render within the header area of the page.
   */
  renderHeader: () => React.ReactNode;
  /**
   * Content to render within the footer area of the page.
   */
  renderFooter: () => React.ReactNode;
};

const GlobalLayout = (props: Props) => {
  return (
    <React.Fragment>
      {props.renderHeader()}
      <UniversalNavPageLayout>
        {props.children}
        {props.renderFooter()}
      </UniversalNavPageLayout>
    </React.Fragment>
  );
};

GlobalLayout.defaultProps = {
  renderHeader: () => <UniversalNav />,
  renderFooter: () => <ContentFooter />,
};

export default GlobalLayout;
